import React from 'react';
import { FormTemplate, RelativeRow, TextInput, Text, ItemsList } from 'ui-builder';
import {
  SenderEmail,
  SetSenderEmailRequest,
  useSenderEmailService,
  VerificationStatus
} from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';
import VerificationCodeForm from './VerificationCodeForm';
import { useVerifiedDomainsContext } from './SenderEmailWidget';

function VerifiedDomainsList() {
  const verifiedDomainsContext = useVerifiedDomainsContext();

  return (
    <Text>
      Please enter the email address you wish to use for sending emails.
      {' '}
      Note that the email must belong to one of the following approved domains:
      <ItemsList items={verifiedDomainsContext.map((item) => item.domain)} />
    </Text>
  )
}

export function SenderEmailForm(
  props: {
    personId: number,
  }
) {
  const senderEmailService = useSenderEmailService();

  const popupFormManager = usePopupFormManager();

  return (
    <FormTemplate<SetSenderEmailRequest, SenderEmail>
      title="Set Sending Email"
      submitFormFunc={async (data) => {
        return await senderEmailService.setSenderEmail(props.personId, data);
      }}
      afterSubmitFunc={async (data) => {
        if (data.status === VerificationStatus.PENDING) {
          popupFormManager.openForm(
            <VerificationCodeForm personId={props.personId}

                                  senderEmail={data} />
          );
        } else {
          popupFormManager.closePopup();
        }
      }}
      validationSchema={{
        email: {
          type: 'string',
          constraints: {
            required: true,
            email: true,
          },
        },
      }}
    >
      <VerifiedDomainsList />
      <RelativeRow weights={[8, 4]}>
        <TextInput source="email" label="Email" />
      </RelativeRow>
    </FormTemplate>
  );
}
